<div class="error-page-wrapper">
  <div class="error-page-left__section">
    <div class="error-page-content">
      <h2 class="c11n-space--force c11n-text-3xl-headline c11n-space-stack-5x">{{ AEM_ERROR_HEADER}}</h2>
      <p class="c11n-space--force c11n-text-lg c11n-space-stack-4x">{{AEM_ERROR_CONTENT_ONE}}</p>
      <p class="c11n-space--force c11n-text-lg c11n-space-stack-4x">{{AEM_ERROR_CONTENT_TWO}}
        <a class="c11n-link c11n-link--secondary" href="{{FUND_LITERATURE_ERROR_HOME_URL}}">
          <span class="c11n-link__content">{{AEM_ERROR_CONTENT_THREE}}</span>
        </a> {{AEM_ERROR_CONTENT_FOUR}}
      </p>
    </div>
  </div>
  <div class="error-page-right__section d-flex align-items-center justify-content-center">
    <img src="{{FUND_LITERATURE_ERROR_SVG_URL}}" alt="error" class="img-fluid" />
  </div>
</div>
